import React, { useContext, useEffect, useState } from "react";
import { isMobile } from "../../utils/utils";

import Close from "../../VibehutUI/Icons/Close";
import PushNotificationBannerAction from "./PushNotificationBannerAction";
import useIsPWA from "../../hooks/usePWA";
import { StoreContext } from "../../Context/StoreContext";

function PushNotificationBanner() {
  const isPWA = useIsPWA();
  const { state } = useContext(StoreContext);
  const {
    auth: { user: authUser },
  } = state;
  const [isPushNotificationBannerSeen, setIsPushNotificationBannerSeen] =
    useState(true);

  useEffect(() => {
    const isPushNotification = JSON.parse(
      localStorage.getItem("isPushNotificationBannerSeen")
    );
    setIsPushNotificationBannerSeen(isPushNotification);
  }, []);
  const handleClose = () => {
    localStorage.setItem("isPushNotificationBannerSeen", JSON.stringify(true));
    setIsPushNotificationBannerSeen(true);
  };

  if (isPushNotificationBannerSeen) {
    return <></>;
  }

  return (
    <div className="relative md:bg-gradient-to-r bg-gradient-to-b from-primary to-lightPurple text-white p-4 shadow-md rounded-lg mt-4 md:mt-0">
      <div className="container md:mx-auto mx-0 flex md:items-center gap-2 md:gap-0 justify-between md:flex-row flex-col">
        <div>
          <div className="flex gap-1 items-center">
            <p className="font-medium">
              Vibehut.io now has PWA push notifications
            </p>
            <a
              href="https://diamondapp.com/posts/baf3465dab0fee971626c43216bee08067d24e5b922d776bc8a81241d70fb309?tab=posts"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                />
              </svg>
            </a>
          </div>

          <p className="text-sm">
            Stay updated with real-time alerts and notifications.
          </p>
        </div>
        {(!isMobile() || isPWA) && authUser?.token && (
          <PushNotificationBannerAction />
        )}
      </div>
      <span
        className=" bg-matteGray absolute dark:text-black cursor-pointer text-white p-1.5 rounded-full -right-1 -top-1"
        onClick={handleClose}
      >
        <Close color="#fff" ratio="10" />
      </span>
    </div>
  );
}

export default PushNotificationBanner;
